import { render, staticRenderFns } from "./ListaSolicitacoesFornecedores.vue?vue&type=template&id=ccefc48e&scoped=true&"
import script from "./ListaSolicitacoesFornecedores.vue?vue&type=script&lang=js&"
export * from "./ListaSolicitacoesFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./ListaSolicitacoesFornecedores.vue?vue&type=style&index=0&id=ccefc48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccefc48e",
  null
  
)

component.options.__file = "ListaSolicitacoesFornecedores.vue"
export default component.exports